<div class="range-input" [class.range-input--dark]="isDark">
	<div class="range-input__range-container">
		<div class="range-input__amount-display"
			[class.range-input__amount-display--editing]="enableQuickSelection && isEditing"
			[ngStyle]="{ left: 'clamp(30px, calc(' + sliderProgress + '% + ' + (10 - sliderProgress * 0.2) + 'px), calc(100% - 30px))' }">
			<div class="range-input__manual" *ngIf="enableQuickSelection && isEditing; else amountView">
				<span class="range-input__manual-prefix">$</span>
				<input
					#amountInput
					type="text"
					inputmode="numeric"
					class="range-input__manual-input"
					[attr.dark]="isDark"
					[(ngModel)]="formattedAmount"
					(keyup.enter)="commitEditing()"
					(blur)="commitEditing()" />
				<button
					type="button"
					class="range-input__manual-confirm"
					(mousedown)="$event.preventDefault()"
					(click)="commitEditing()">
					<i class="bi bi-check-lg"></i>
				</button>
			</div>
			<ng-template #amountView>
				<button
					*ngIf="enableQuickSelection && !isManualChangeDisable; else staticAmount"
					type="button"
					class="range-input__amount-btn"
					(click)="startEditing()">
					<span>{{ formattedAmount }}</span>
					<i class="bi bi-pencil-fill range-input__amount-pencil"></i>
				</button>
				<ng-template #staticAmount>
					<span>{{ formattedAmount }}</span>
				</ng-template>
			</ng-template>
		</div>
		<input
			type="range"
			class="range-input__range"
			[ngClass]="{ 'range-input__range--dark': isDark }"
			[ngStyle]="{ 'background-size': sliderProgress + '% 100%' }"
			[min]="mininumAmount"
			[max]="maximumAmount"
			[(ngModel)]="amount"
			(change)="onAmountRangeChange()"
			(input)="onSliderInput($event)"
			[step]="jump" />
		<div class="range-input__labels">
			<span>${{ mininumAmount | number }}</span>
			<span>${{ maximumAmount | number }}</span>
		</div>
	</div>

	<section class="range-input__quick" *ngIf="enableQuickSelection">
		<button
			type="button"
			class="range-input__quick-chip"
			(click)="setToMinimum()">
			Mín
		</button>
		<button
			type="button"
			class="range-input__quick-chip"
			*ngFor="let quickAmount of visibleQuickAmounts"
			(click)="selectQuickAmount(quickAmount)">
			{{ quickAmount | number }}
		</button>
		<button
			type="button"
			class="range-input__quick-chip"
			(click)="setToMaximum()">
			Máx
		</button>
	</section>

	<section class="range-input__input-container">
		<button
			cmvBtn="icon"
			class="range-input__btn"
			(click)="onDecrementAmount()"
			[disabled]="isDecrementButtonDisable">
			<i class="bi bi-dash-circle"></i>
		</button>
		<input
			type="text"
			[attr.dark]="isDark"
			(change)="onManualAmountChange()"
			[(ngModel)]="formattedAmount"
			[disabled]="isManualChangeDisable" />
		<button
			cmvBtn="icon"
			class="range-input__btn"
			[disabled]="isIncrementButtonDisable"
			(click)="onIncrementAmount()">
			<i class="bi bi-plus-circle"></i>
		</button>
	</section>
</div>
